import Characters from "./Characters";

export default Characters;